import React from 'react';
import { useSelector } from 'react-redux';
import { isMobileSel } from '@screen';
import PendingItemsTableDesktop from './PendingItemsTable';
import PendingItemsList from './PendingItemsList';

const PendingItemsTable = (props) => {
  const isMobile = useSelector(isMobileSel);

  return isMobile
    ? (<PendingItemsList {...props} />)
    : (<PendingItemsTableDesktop {...props} />);
};

export default PendingItemsTable;
